import { render, staticRenderFns } from "./ReceivedMessageList.vue?vue&type=template&id=c3d47232&scoped=true"
import script from "./ReceivedMessageList.vue?vue&type=script&lang=js"
export * from "./ReceivedMessageList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/all_messages.css?vue&type=style&index=0&id=c3d47232&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d47232",
  null
  
)

export default component.exports